import { DrillPageContext } from "@-/dev.improve.haniverse.routes.nav.app.learn.drill._context";
import { DrillFooterMeaningView } from "@-/dev.improve.haniverse.routes.nav.app.learn.drill._components.footer.__views.meaning";
import { DrillFooterPronunciationView } from "@-/dev.improve.haniverse.routes.nav.app.learn.drill._components.footer.__views.pronunciation";
import { DrillFooterSentenceGlyphsView } from "@-/dev.improve.haniverse.routes.nav.app.learn.drill._components.footer.__views.sentence-glyphs";
import { DrillFooterSentenceSpeechView } from "@-/dev.improve.haniverse.routes.nav.app.learn.drill._components.footer.__views.sentence-speech";
import { DrillPageSentenceRatingFooter } from "#drill-page-sentence-rating-footer";
import { View } from "@-/com.npmjs.react-native";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";

export function DrillPageFooter() {
  const [drillType] = useContextSelectors(DrillPageContext, (c) => c.drillType);
  const [sentenceDrill] = useContextSelectors(DrillPageContext, (c) => c.sentenceDrill);

  // The sentence-production drills answer a whole sentence incrementally, so neither the single
  // answer box nor the plain pinyin keyboard fits. Checked FIRST: both of the fallthroughs below
  // would otherwise claim these kinds.
  if (sentenceDrill !== null) {
    // Once revealed the drill is over and the footer becomes the rating prompt — the input is spent
    // and leaving it up would invite answers that can no longer be recorded.
    if (sentenceDrill.state.isFinished) {
      return <DrillPageSentenceRatingFooter sentenceDrill={sentenceDrill} />;
    }
    if (drillType.kind === "sentence-glyphs") {
      return <DrillFooterSentenceGlyphsView sentenceDrill={sentenceDrill} />;
    }
    return <DrillFooterSentenceSpeechView sentenceDrill={sentenceDrill} />;
  }

  // A word card's answer is free text (its characters' backs, space-joined), so it uses the
  // meaning view's plain input rather than the pinyin keyboard. Checked before the pronunciation
  // fallthrough below, which would otherwise open Shuangpin for a non-pinyin answer.
  if (drillType.kind === "meaning" || drillType.kind === "word-sentence") {
    return (
      <View className="size-full flex-col">
        <DrillFooterMeaningView />
      </View>
    );
  }

  return <DrillFooterPronunciationView />;
}
